import React from "react";
import { toast } from "react-toastify";
import { DeleteMenuButton } from "~/components/common/parts/button/DeleteMenuButton";
import { ConfirmModal } from "~/components/common/parts/modal/ConfirmModal";
import { TableRow } from "~/components/common/parts/table/TableRow";
import { useImportConversions } from "~/hooks/admin/useImportConversions";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import type { ImportConversion } from "~/models/ImportConversion";
import type { ImportType } from "~/models/ImportLog";
import { isSuccess } from "~/utils/api/api_handler";
import { destroy } from "~/utils/api/ImportConversion";

type Props = {
	importConversion: ImportConversion;
	importType: ImportType;
};

export const ImportConversionTableRow: React.FC<Props> = ({
	importType,
	importConversion
}: Props) => {
	const { mutate } = useImportConversions().useIndex(importType);
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	const handleAccept = React.useCallback(async () => {
		const response = await destroy(importConversion.id, importType);
		if (isSuccess(response)) {
			await mutate();
			toast.success("削除しました");
			handleClose();
			return;
		}
		toast.error("削除に失敗しました");
	}, [handleClose, importConversion.id, importType, mutate]);
	return (
		<TableRow>
			<td>{importConversion.columnName}</td>
			<td>{importConversion.originalValue}</td>
			<td>{importConversion.convertedValue}</td>
			<td>
				<DeleteMenuButton onClick={handleOpen}>削除</DeleteMenuButton>
				<ConfirmModal
					confirmType="delete"
					handleAccept={handleAccept}
					handleCancel={handleClose}
					isOpen={isOpen}
				>
					削除してよろしいですか？
				</ConfirmModal>
			</td>
		</TableRow>
	);
};
